<template>
  <div class="mb-8" :class="!editable && 'divide-y divide-slate-200'">
    <template v-if="editable">
      <EditableFormDetailedListItem v-for="(item, index) in list" :key="index" :item="item" :index="index"
                                    :icon="icon" :small="small" :editable="editable" :item-count="itemCount"
                                    @update:order="changeOrder(index, $event)" :allows="allows"
                                    @update:item="updateItem(index, $event)" @delete:item="deleteItem(index)"/>
      <FormButton @click="addEntry" color="gradient" class="mx-auto block max-w-fit -mb-2">
        Add New {{ name }}
      </FormButton>
    </template>
    <FormListDetailed v-else-if="filteredList?.length" :icon="icon" :small="small" :list="filteredList"/>
  </div>
</template>

<script setup>
import {computed} from "vue";
import EditableFormDetailedListItem from "./EditableFormDetailedListItem.vue";
import FormListDetailed from "./FormListDetailed.vue";
import FormButton from "./FormButton.vue";

const emits = defineEmits(["update:list"]);
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  icon: {
    type: [Object, Function],
    required: true,
  },
  small: Boolean,
  editable: Boolean,
  allows: Object,
  name: String,
});

const filteredList = computed(() => {
  if (!props.list || !Array.isArray(props.list)) return [];
  return props.list.filter((item) => {
    if (!item) return false;
    if (typeof item === "string") return true;
    return item?.primary || item?.type || item?.title || item?.description || item?.link || item?.subtitle;
  });
});

const addEntry = () => {
  let list;

  if (!props.list) list = [];
  else list = [...props.list];

  let item = {
    ...(props.allows?.primary && {primary: ""}),
    ...(props.allows?.title && {title: ""}),
    ...(props.allows?.subtitle && {subtitle: ""}),
    ...(props.allows?.start && {start: null}),
    ...(props.allows?.end && {end: null}),
    ...(props.allows?.description && {description: ""}),
    ...(props.allows?.rank && {rank: 1}),
    ...(props.allows?.completion && {completion: null}),
    ...(props.allows?.tenure && {tenure: 0}),
    ...(props.allows?.type && {type: ""}),
    isNew: true,
  };

  list.push(item);

  emits("update:list", list);
};

const changeOrder = (index, direction = 0) => {
  let list;
  if (!props.list) list = [];
  else list = [...props.list];
  const item = list[index];
  list.splice(index, 1);
  list.splice(index + direction, 0, item);
  emits("update:list", list);
};

const updateItem = (index, value) => {
  let list;
  if (!props.list) list = [];
  else list = [...props.list];
  list[index] = value;
  emits("update:list", list);
};

const deleteItem = (index) => {
  let list;
  if (!props.list) list = [];
  else list = [...props.list];
  list.splice(index, 1);
  emits("update:list", list);
};

const itemCount = computed(() => props.list?.length || 0);
</script>
